import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL;

const axiosConfig = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const getListClass = async (token, search, currentPage, sizePage) => {
  const apiUrl = search
    ? `${API_BASE_URL}/classes/admin/search/${search}/${currentPage}/${sizePage}`
    : `${API_BASE_URL}/classes/admin/${currentPage}/${sizePage}`;

  try {
    const response = await axios.get(apiUrl, axiosConfig(token));

    return response;
  } catch (error) {
    return error;
  }
};

export const getClassById = async (token, id) => {
  const response = await axios.get(
    `${API_BASE_URL}/classes/admin/${id}`,
    axiosConfig(token)
  );

  try {
    return response;
  } catch (error) {
    return error;
  }
};

export const saveOrEditClass = async (token, id, body) => {
  const apiUrl = id
    ? `${API_BASE_URL}/classes/edit/${id}`
    : `${API_BASE_URL}/classes/create`;
  const method = id ? "patch" : "post";
  const response = await axios[method](apiUrl, body, axiosConfig(token));
  try {
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteClass = async (token, id, body) => {
  const response = await axios.delete(`${API_BASE_URL}/classes/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: body,
  });
  try {
    return response;
  } catch (error) {
    return error;
  }
};
